var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactJsHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 144,
    viewBox: "0 0 203 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.446 82.4182C107.2 82.4182 111.864 77.7536 111.864 71.9996C111.864 66.2456 107.2 61.5811 101.446 61.5811C95.6919 61.5811 91.0273 66.2456 91.0273 71.9996C91.0273 77.7536 95.6919 82.4182 101.446 82.4182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.445 93.3489C132.321 93.3489 157.35 83.7923 157.35 72.0035C157.35 60.2148 132.321 50.6582 101.445 50.6582C70.5703 50.6582 45.541 60.2148 45.541 72.0035C45.541 83.7923 70.5703 93.3489 101.445 93.3489Z",
    stroke: "white",
    strokeWidth: 5.08222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9625 82.6731C98.4001 109.412 119.191 126.309 129.4 120.415C139.61 114.521 135.371 88.0665 119.934 61.3278C104.496 34.5891 83.7052 17.6914 73.4958 23.5858C63.2865 29.4801 67.5249 55.9344 82.9625 82.6731Z",
    stroke: "white",
    strokeWidth: 5.08222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9623 61.3291C67.5247 88.0678 63.2863 114.522 73.4957 120.416C83.705 126.311 104.496 109.413 119.934 82.6745C135.371 55.9358 139.609 29.4814 129.4 23.5871C119.191 17.6927 98.3999 34.5904 82.9623 61.3291Z",
    stroke: "white",
    strokeWidth: 5.08222
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.891,
    height: 104,
    fill: "white",
    transform: "translate(43 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactJsHover);
export default __webpack_public_path__ + "static/media/ReactJSHover.a394320faa8383704d0d1012935565bb.svg";
export { ForwardRef as ReactComponent };